import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import HelpSupportComp from './HelpSupportComp';

function HelpSupport() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <HelpSupportComp />
      </div>
    </div>
  );
}

export default HelpSupport;
